import { produce } from 'immer'
import {
    SET_MONITORING_ALERT_LIST,
    SET_MONITORING_CONFIG,
    SET_MONITORING_CONFIGURATIONS,
    SET_MONITORING_SUMMARY
} from 'actions/monitoring'

const initialState = {
    alertList: [],
    config: {},
    configurations: {
        data: [],
        headers: {}
    },
    summary: null
}

export const monitoringReducer = (state = initialState, action) => {
    return produce(state, draft => {
        switch (action.type) {
            case SET_MONITORING_ALERT_LIST:
                draft.alertList = action.data
                draft.alertHeaders = action.headers
                break;
            case SET_MONITORING_CONFIG:
                draft.config = action.data
                break;
            case SET_MONITORING_CONFIGURATIONS:
                draft.configurations = {
                    data: action.data,
                    headers: action.headers
                }
                break;
            case SET_MONITORING_SUMMARY:
                draft.summary = action.data
                break;
            default:
                break;
        }
    })
}